/**
 * 견적서 작성 창의 단가 입력 규칙 (GS A3-11).
 *
 * 단가는 원 단위 정수다. 종전에는 `parseFloat` 로 읽어 «1112.5» 가 소수 그대로 저장되고,
 * 상한이 없어 17자리 값이 정밀도를 잃은 채 표시됐다. 서버(`QuoteResponseItemDto.unitPrice`)도
 * 정수·10조 상한으로 막는다 — 두 곳의 상한을 같게 둔다.
 */

/** 단가 상한 — 서버 `@Max(10000000000000)` 와 같다(10조 원). */
export const MAX_QUOTE_UNIT_PRICE = 10_000_000_000_000;

/**
 * 입력칸 글자 → 원 단위 정수.
 *  - 소수점 뒤는 버린다(원 단위).
 *  - 쉼표·공백 등 숫자가 아닌 글자는 무시한다.
 *  - 비었으면 0, 상한을 넘으면 상한으로 묶는다.
 */
export function parseUnitPriceInput(raw: string): number {
  const integerPart = raw.split(".")[0] ?? "";
  const digits = integerPart.replace(/[^0-9]/g, "");
  if (digits === "") return 0;
  // 상한(14자리)을 넘는 자릿수는 어차피 상한으로 묶이므로 앞 16자리만 숫자로 바꾼다.
  const value = Number(digits.slice(0, 16));
  return Math.min(value, MAX_QUOTE_UNIT_PRICE);
}
